// extracted by mini-css-extract-plugin
export default {"wrapper":"EquipmentSkeleton_wrapper_j_uns"};